import * as React from "react";
import { Form, Spin, Table, InputNumber } from "antd";
import { IRuleGroup } from "../../../model/evaluation/RuleGroup";
import { IRuleGroupElementPresentationModel } from "../../../presenter/evaluation/RuleGroupsPresenter";
import { IRuleGroupElement } from "../../../model/evaluation/RuleGroupElement";

export interface Props {
  getFieldDecorator?: any;
  translate: any;
  rowData?: IRuleGroup;
  codebooks?: any;
  selectRuleGroupElements?: any;
  setSelectedBusinessRuleIds?: any;
  setElements?: any;
}
export interface State {
  loading: boolean;
  elements: IRuleGroupElementPresentationModel[];

  selectedRowKeys?: string[];
}

export default class BusinessRuleToGroupAssignationForm extends React.Component<
  Props,
  State
> {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: true,
      elements: [],
      selectedRowKeys: []
    };
    this.getAssignedRules = this.getAssignedRules.bind(this);
  }

  async componentDidMount() {
    return this.getAssignedRules();
  }

  async getAssignedRules() {
    const { codebooks, rowData } = this.props;
    if (codebooks) {
      if (typeof codebooks === "function") {
        const data = await codebooks(rowData);
        const rowKeys = data.get
          .filter(item => item.selected)
          .map(item => item.rule.id.toString());

        this.setState({
          loading: false,
          elements: data.get,
          selectedRowKeys: rowKeys
        });
      }
    }
  }
  async setElementDisplayNumberValue(record: any, value: number) {
    let { elements } = this.state;
    let newElement = elements.find(item => item.rule.id === record.rule.id);
    if (!newElement) {
      if (record.element) {
        record.element.displayNumber = value;
      } else {
        let element = {} as IRuleGroupElement;
        element.displayNumber = value;
        record.element = element;
      }
      elements.push(record);
    } else if (newElement) {
      const indexOfNewElement = elements.indexOf(newElement);
      if (newElement.element) {
        newElement.element.displayNumber = value;
      } else {
        let element = {} as IRuleGroupElement;
        element.displayNumber = value;
        newElement.element = element;
      }
      elements[indexOfNewElement] = newElement;
    }
    this.props.setElements(elements);
    this.props.setSelectedBusinessRuleIds(this.state.selectedRowKeys);
    this.setState({ elements });
  }
  async setElementWeightFactorValue(record: any, value: number) {
    let { elements } = this.state;
    let newElement = elements.find(item => item.rule.id === record.rule.id);
    if (!newElement) {
      if (record.element) {
        record.element.weightFactor = value;
      } else {
        let element = {} as IRuleGroupElement;
        element.weightFactor = value;
        record.element = element;
      }
      elements.push(record);
    } else if (newElement) {
      const i = elements.indexOf(newElement);
      if (newElement.element) {
        newElement.element.weightFactor = value;
      } else {
        let element = {} as IRuleGroupElement;
        element.weightFactor = value;
        newElement.element = element;
      }
      elements[i] = newElement;
    }
    this.setState({ elements });
    this.props.setElements(elements);
    this.props.setSelectedBusinessRuleIds(this.state.selectedRowKeys);
  }

  onSelectChange = selectedRowKeys => {
    this.props.setSelectedBusinessRuleIds(selectedRowKeys);
    this.props.setElements(this.state.elements);
    this.setState({ selectedRowKeys });
  };

  render() {
    const { translate } = this.props;
    const { selectedRowKeys } = this.state;
    const columns = [
      {
        title: translate("ruleGroups_page.assigned_rule_column_title"),
        dataIndex: "rule.description"
      },
      {
        title: translate("ruleGroups_page.displayNumber"),
        dataIndex: "element.displayNumber",
        editable: true,
        render: (text, record) => {
          return (
            <InputNumber
              required
              min={1}
              placeholder={text}
              onBlur={e =>
                this.setElementDisplayNumberValue(record, +e.currentTarget.value)
              }
            />
          );
        }
      },
      {
        title: translate("ruleGroups_page.weightFactor"),
        dataIndex: "element.weightFactor",
        editable: true,
        render: (text, record) => {
          return (
            <InputNumber
              max={1}
              min={0}
              step={0.01}
              placeholder={text}
              onBlur={e =>
                this.setElementWeightFactorValue(record, +e.currentTarget.value)
              }
            />
          );
        }
      }
    ];

    const rowSelection = {
      onChange: this.onSelectChange,
      getCheckboxProps: record => ({
        name: record.name
      }),
      selectedRowKeys
    };
    return (
      <Form>
        <Spin spinning={this.state.loading}>
          <br />
          <Table
            rowKey={record => record.rule.id.toString()}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={this.state.elements}
          />
        </Spin>
      </Form>
    );
  }
}
